define('models/reseller_product',['require','backbone','models/product'],function(require){

    var Backbone = require('backbone');

    var ProductModel = require('models/product');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'reseller-products/' + this.id + '/' ) :
                ( App.Config.apiBase + 'reseller-products/' );
        },

        defaults: function () {
            return {
                id: null,
                product: new ProductModel().attributes,
                count: 0,
                total_count: 0
            };
        }
    });
});
